import _asyncToGenerator from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { props } from 'node_modules/vue-barcode'
import request from "../../utils/request";
import _ from "lodash";
import { cmpPos } from 'codemirror';
export default {
  name: "DownTable",
  props: {
    requestUrl: "",
    columnData: Array,
    parent: Object,
    // 暂未使用
    params: "",
    placeholder: "",
    disabled: false,
    rowName: '',
    //要显示的值字段
    is_need: 0
  },
  watch: {
    //   value4:{
    //   deep: true,
    //   immediate:true,
    //    handler: function(e) {
    //     this.$emit('getVal',e)
    //   }
    // },
    row: {
      deep: true,
      immediate: true,
      handler: function handler(e) {
        var a = JSON.stringify(e);
        this.$emit("getVal", a);
      }
    },
    params: {
      deep: true,
      immediate: true,
      handler: function handler(e) {
        this.formData.value4 = e;
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      // value4: "",
      tableData: [],
      tableColumn: [],
      fetchTableData: [],
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 50, 100]
      },
      row: {},
      formData: {
        value4: ""
      },
      rules: {
        value4: [{
          required: true,
          message: "请输入信息",
          trigger: ""
        }]
      }
    };
  },
  created: function created() {
    this.load();

    if (this.placeholder != '') {
      this.rules.value4[0].message = '请输入' + this.placeholder;
    }
  },
  mounted: function mounted() {
    this.keyupEvent = _.debounce(this.keyupEvent, 300);
  },
  methods: {
    getFoucs: function getFoucs() {
      this.load();
    },
    load: function load() {
      var _this = this;

      if (this.columnData.length > 0) this.tableColumn = this.columnData; //   const { row, column } = this.params
      //   this.row = row
      //   this.column = column

      this.formData.value4 = this.params;
      this.fetchData().then(function (data) {
        _this.tableData = data;
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return request({
                  url: _this2.requestUrl,
                  method: "get",
                  params: {
                    keyword: _this2.formData.value4,
                    pageSize: _this2.tablePage.pageSize,
                    page: _this2.tablePage.currentPage
                  }
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.fetchTableData = res.data.list;
                    _this2.tablePage.total = res.data.count;
                  }
                }).catch(function (err) {});

              case 2:
                return _context.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(_this2.fetchTableData);
                  }, 0);
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    keydownEvent: function keydownEvent(params) {
      var $event = params.$event,
          $grid = params.$grid;

      if ($event.keyCode == 27) {
        // Escape 取消
        this.$refs.xDown.hidePanel();
      }

      if ($event.keyCode == 13) {
        var currRow = $grid.getCurrentRecord();
        this.formData.value4 = currRow.name;
        this.row = currRow;
        this.$refs.xDown.hidePanel();
      }
    },
    pageChangeEvent: function pageChangeEvent(_ref) {
      var _this3 = this;

      var currentPage = _ref.currentPage,
          pageSize = _ref.pageSize;
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.loading = true;
      this.fetchData().then(function (data) {
        _this3.loading = false;
        _this3.tableData = data;
      });
    },
    doubleEvent: function doubleEvent(params) {
      var _this4 = this;

      this.row = params.row; // 更新原始row数据

      this.tableColumn.forEach(function (item) {
        if (item.type != "seq" && item.field) {
          if (_this4.rowName == '' || _this4.rowName == undefined) {
            _this4.formData.value4 = params.row.name;
          } else {
            var rname = _this4.rowName;
            _this4.formData.value4 = params.row[rname];
          }

          _this4.row = params.row;
        }
      });
      this.$refs.xDown.hidePanel(); // 触发父表格更新
      //   this.params.$table.updateStatus({ row, column });
    },
    selectEvent: function selectEvent(params) {// console.log('单击: ', params)
      // const { row, column } = this
      // row[column.property] = params.row.name
      // this.$refs.xDown.hidePanel()
    },
    keyupEvent: function keyupEvent(params) {
      var _this5 = this;

      var $event = params.$event,
          value = params.value; // const { row, column } = this;

      var cellValue = params.value;

      if ($event.keyCode == 40 || $event.keyCode == 13 || $event.keyCode == 38) {
        // ArrowDown 下箭头 ， Enter 回车 ， ArrowUp 上箭头
        this.$refs.vxeInput.blur();
        setTimeout(function () {
          _this5.$refs.vxeGrid.focus();

          if (!_this5.$refs.vxeGrid.getCurrentRecord()) _this5.$refs.vxeGrid.setCurrentRow(_this5.tableData[0]);
        }, 0);
        return;
      }

      this.loading = true;
      this.fetchData().then(function (data) {
        _this5.loading = false;

        _this5.$refs.xDown.showPanel(); // if (cellValue) {
        //   this.tableData = data.filter(item => item.name.indexOf(cellValue) > -1)
        // } else {


        _this5.tableData = data; // }
      });
    },
    suffixClick: function suffixClick() {
      this.$refs.xDown.togglePanel();
    },
    clickEvent: function clickEvent() {
      this.$refs.xDown.showPanel();
    }
  }
};